<template>
    <div class="slideout-inner" id="products-from-offer-event">
      <div class="slideout-close" @click="$parent.closeSlideout()">
        <i class="fas fa-times"></i>
      </div>
        <div class="template-header-wrapper">
          <h3> Oferte </h3>
          <div class="template-header">
            <div class="template-left-side">
              <div class="template-search-container">
                <div class="search-form">
                  <input
                  class="search-input"
                  type="search"
                  :placeholder="$t('placeholder.cautaProdus')"
                  name="q"
                  v-model="search"
                  id="product-search-offer"
                  autocomplete="off"
                  @input="searchProductsFromOffer()">
                  <span class="focus-input"></span>
                  <span class="symbol-input">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
              <div class="template-dropdown-group">
                <div class="template-dropdown-button" :key="componentFilterIdKey" id="filter-id">
                  <b-dropdown id="dropdown-form1" text="NR" ref="dropdown">
                    <b-dropdown-form class="innner-dropdown-content">
                      <b-form-checkbox v-for="(offer,index) in offersAll" :key="index"
                      @change="addRemoveFilter('id', offer.id)">
                      {{offer.id}}
                    </b-form-checkbox>
                    <!-- <span class="close-dropdown-filter" @click="closeFiltersDropdown('filter-id')">
                      <i class="far fa-times-circle"></i>
                    </span> -->
                  </b-dropdown-form>
                </b-dropdown>
                <span class="template-reset-filter" @click="resetFilter('id', 'componentFilterIdKey')"
                v-if="offerFilter['id'].length > 0">
                <i class="fas fa-sync-alt"></i>
              </span>
            </div>
            <div class="template-dropdown-button" :key="componentFilterDateKey" id="filter-date">
              <b-dropdown id="dropdown-form2" text="Data" ref="dropdown">
                <b-dropdown-form class="innner-dropdown-content">
                  <b-form-checkbox v-for="(date,index) in offerDates()" :key="index"
                  @change="addRemoveFilter('created_at', date)">
                  {{date}}
                </b-form-checkbox>
                <!-- <span class="close-dropdown-filter" @click="closeFiltersDropdown('filter-date')">
                  <i class="far fa-times-circle"></i>
                </span> -->
              </b-dropdown-form>
            </b-dropdown>
            <span class="template-reset-filter" @click="resetFilter('created_at','componentFilterDateKey')"
            v-if="offerFilter['created_at'].length > 0">
            <i class="fas fa-sync-alt"></i>
          </span>
        </div>
        <div class="template-dropdown-button" :key="componentFilterObjeKey" id="filter-objective">
          <b-dropdown id="dropdown-form3" text="Obiectiv" ref="dropdown">
            <b-dropdown-form class="innner-dropdown-content">
              <!-- <b-form-checkbox v-for="(objective,index) in offerObjectives2()" v-model="objective.status" :key="index" @change="addRemoveFilter('objective', objective)" v-if="objective && objective !=null">
              {{objective.objective}}
            </b-form-checkbox>-->
            <b-form-checkbox v-for="(objective,index) in offerObjectives()"
            v-model="objective.status" :key="index"
            @change="addRemoveFilter('objective', objective)"
            v-if="objective && objective !=null">
            {{objective}}
          </b-form-checkbox>
          <!-- <span class="close-dropdown-filter" @click="closeFiltersDropdown('filter-objective')">
            <i class="far fa-times-circle"></i>
          </span> -->
        </b-dropdown-form>
      </b-dropdown>
      <span class="template-reset-filter" @click="resetFilter('objective', 'componentFilterObjeKey')"
      v-if="offerFilter['objective'].length > 0">
      <i class="fas fa-sync-alt"></i>
    </span>
  </div>
</div>
</div>
<div class="template-right-side">
  <div class="template-list-legend">
    <ul>
      <li>
        <span class="template-legend-dot dot-available">  </span>
        <p> Disponibile </p>
      </li>
      <!-- <li>
      <span class="template-legend-dot dot-reserved">  </span>
      <p> Rezervate </p>
    </li> -->
    <li>
      <span class="template-legend-dot dot-billed">  </span>
      <p> Comandate </p>
    </li>
    <li>
      <span class="template-legend-dot dot-ordered">  </span>
      <p> Ofertate </p>
    </li>
  </ul>
  <div class="template-legend-alert">
    <i class="fas fa-exclamation-triangle"></i>
    <span> Numar necesar de produse indisponibil </span>
  </div>
</div>
</div>
          </div>
            <div class="template-collapse-all">
              <span @click="collapseAll()" class="collapse-all">
                <i class="fas fa-grip-lines"></i>
              </span>
            </div>
        </div>
        <div class="template-inner-content">
            <div role="tablist" class="products_from" v-if="offers" :key="componentProductsKey">
                <div class="template-main-item" v-for="(offer, index) in offers" :key="index">
                    <div class="template-item-heading">
                        <div class="template-checkbox-slot" :key="emitOfferRow">
                            <b-form-checkbox v-model="offer.checked" @input="emitOffer(offer.id, index)"></b-form-checkbox>
                        </div>
                        <div class="template-main-info" v-b-toggle="preventToggle ? false : 'collapse-offer'+index"
                             @click="template = index">
                            <div class="template-order-nr">
                                <p> {{offer.id}} </p>
                            </div>
                            <div class="template-gn-info">
                                <p> {{offer.created_at}} </p>
                            </div>
                            <div class="template-order-obj">
                                <p> {{offer.objective}} </p>
                            </div>
                            <div class="show-all-products">
                                <p class="show-every-order" v-if="isSearching"
                                   @click="showAllProductsFromOffer(index, offer.id, $event)"> X </p>
                            </div>
                            <div class="template-collapse-icon">
                                <i class="fas fa-grip-lines"></i>
                            </div>
                        </div>
                    </div>
                    <b-collapse visible :id="'collapse-offer'+index">
                        <div class="template-inner-accordion" :key="emitProductRow">
                            <div class="template-accordion-row"
                                 :class="product.qty_available <= product.qty_total - product.qty_ordered ? 'template-row-warning' : '' "
                                 v-for="(product, indexProd) in offer.products" :key="indexProd">
                                <div class="template-accordion-checkbox">
                                    <b-form-checkbox v-model="product.checked"
                                                     @input="emitProduct(offer.id, product.id, true, product)"
                                                     class="hide-b-form-checbox-products-from-order"

                                    >

                                    </b-form-checkbox>
                                </div>
                                <div class="template-item-name">
                                    <h1 @click="toggleTargetProductCheckedStatus(offer.id, product.id, indexProd)"> {{product.name}} </h1>
                                </div>
                                <div class="template-item-qty">
                                    <div class="template-input-qty">
                                        <input data-product-can-be-added="true"
                                               :data-product="offer.id + '-' + product.id"
                                               :data-product-active-offer="index + '-' + indexProd"
                                               @click="activateQtyInputOffer(index, indexProd)"
                                               @input="emitProduct(offer.id, product.id, false, product)" type="number"
                                               v-model="product.qty_input" :data-warehouse-id="product.warehouse_id"
                                               :data-warehouse-name="getWarehousesById(product.warehouse_id).name"
                                               :data-warehouse-key="getWarehousesById(product.warehouse_id).key"/>
                                    </div>
                                    <div class="template-item-pending">
                                        <span class="billed-items"> {{product.qty_ordered || 0 }} </span>
                                        <span class="ordered-items"> {{product.qty_total || 0 }} </span>
                                    </div>
                                </div>
                                <div class="template-item-price">
                                    <p> {{product.price | formatPrice }}</p>
                                </div>
                                <div class="template-item-status">
                                    <span class="available-items"> {{product.qty_available || 0 }} </span>
                                    <!-- <span class="reserved-items"> {{product.qty_reserved || 0 }} </span> -->
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import OffersService from '../api-services/offers.service'
import { EventBus } from '../main.js'

export default {
  name: 'ProductsFomOffer',
  props: [
    'select_client',
    'warehouses'
  ],
  data () {
    return {
      offers: [],
      offersAll: [],
      offerFilter: {
        'id': [],
        'created_at': [],
        'objective': []
      },
      offerFilterKeys: ['id', 'created_at', 'objective'],
      offerDateFilter: [],
      offerObjectiveFilter: [],
      componentProductsKey: 0,
      componentFilterIdKey: 'id1',
      componentFilterDateKey: 'date1',
      componentFilterObjeKey: 'obj1',
      indexCount: 0,
      lastQtyActiveOffer: { offerIndex: 0, productIndex: 0 },
      search: null,
      offersAfterSearch: [],
      searchOffers: [],
      visible: 0,
      preventToggle: false,
      showAllProductsFromOfferObject: [],
      template: null,
      isSearching: false,
      countHowManyTimes: 0,
      emitOfferRow: 0,
      emitProductRow: 'emitProductRow',
      checkedOffers: []
    }
  },
  watch: {
    select_client: function (val) {
      if (Number.isInteger(this.select_client.id)) {
        this.getUserOffers(this.select_client.id)
      }
    },
    search: function (newVal, oldVal) {
      if (newVal !== '') {
        this.isSearching = true
      } else {
        this.isSearching = false
      }
    }
  },
  mounted () {
    let vm = this
    EventBus.$on('clearUserOffers', (data) => {
      if (data) {
        this.offers = []
        this.offersAll = []
      }
    })
    EventBus.$on('changeClientClearOfferFilter', (data) => {
      if (data) {
        this.offerFilter['created_at'] = []
        this.offerFilter['objective'] = []
        this.offerFilter['date'] = []
        this.componentProductsKey += 1
        this.componentFilterObjeKey += 1
        this.componentFilterDateKey += 1
        this.componentFilterIdKey += 1
      }
    })
    EventBus.$on('uncheckFromOffer', (data) => {
      let offer = this.offersAll.find(o => parseInt(o.id) === parseInt(data.offerId))
      let offerIndex = this.offersAll.findIndex(o => parseInt(o.id) === parseInt(data.offerId))
      let productIndex = []

      offer.products.forEach(function (product, index) {
        if (parseInt(product.id) === parseInt(data.productId)) {
          productIndex.push(index)
        }
      })
      this.offersAll[offerIndex].checked = false
      this.markProductCheckAsFalse(productIndex, offerIndex, this.offersAll)

      offer = this.offers.find(o => parseInt(o.id) === parseInt(data.offerId))
      offerIndex = this.offers.findIndex(o => parseInt(o.id) === parseInt(data.offerId))
      productIndex = offer.products.findIndex(prods => parseInt(prods.id) === parseInt(data.productId))
      this.markProductCheckAsFalse(productIndex, offerIndex, this.offers)
      this.componentProductsKey += 1
    })

    document.getElementById('products-from-offer-event').addEventListener('keydown', event => {
      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-product-active-offer') !== null) {
        event.preventDefault()
        if (event.keyCode === 40) {
          let newproductIndex = vm.lastQtyActiveOffer.productIndex + 1
          if (window.$('[data-product-active-offer=' + vm.lastQtyActiveOffer.offerIndex + '-' + newproductIndex + ']').length > 0) {
            vm.lastQtyActiveOffer.productIndex = newproductIndex
          }
        } else {
          vm.lastDataDiscountActive = vm.lastDataDiscountActive < 1 ? 0 : vm.lastDataDiscountActive - 1
          let newproductIndex = vm.lastQtyActiveOffer.productIndex - 1
          if (window.$('[data-product-active-offer=' + vm.lastQtyActiveOffer.offerIndex + '-' + newproductIndex + ']').length > 0) {
            vm.lastQtyActiveOffer.productIndex = newproductIndex
          }
        }
        window.$('[data-product-active-offer=' + vm.lastQtyActiveOffer.offerIndex + '-' + vm.lastQtyActiveOffer.productIndex + ']').focus().select()
      }
    })
  },
  methods: {
    toggleTargetProductCheckedStatus (offerId, productId, indexProd) {
      let offer = this.offers.find(o => parseInt(o.id) === parseInt(offerId))
      let product = offer.products.find(p => parseInt(p.id) === parseInt(productId))

      if (product.checked) {
        product.checked = false
      } else {
        product.checked = true
      }
      this.emitOfferRow += 1
    },
    markProductCheckAsFalse (productIndexArray, offerIndex, wich) {
      if (productIndexArray.length) {
        for (let i = 0; i < productIndexArray.length; i++) {
          wich[offerIndex].products[productIndexArray[i]].checked = false
        }
      }
    },
    // closeFiltersDropdown (id) {
    //   window.$('#' + id).click()
    // },
    collapseAll () {
      let vm = this
      for (let i = 0; i < this.offers.length; i++) {
        vm.$root.$emit('bv::toggle::collapse', 'collapse-offer' + i)
      }
      let target = document.getElementsByClassName('collapse-all')
      if (this.checkedOffers.length) {
        this.checkedOffers.forEach(function (offerIndex) {
          vm.showOnCollapse(offerIndex)
        })
      } else {
        //
      }
      target[0].classList.toggle('collapsed')
    },
    hideFiltersDropdown () {
      this.$refs.dropdown.hide(true)
    },
    searchProductsFromOffer () {
      let vm = this
      this.applySearch()
      this.offerFilterKeys.forEach(function (element) {
        if (vm.offerFilter[element].length > 0) {
          vm.offers = vm.offers.filter(offer => vm.offerFilter[element].includes(offer[element]))
        }
      })
      this.componentProductsKey += 1
    },
    activateQtyInputOffer (offerIndex, productIndex) {
      this.lastQtyActiveOffer = { offerIndex: offerIndex, productIndex: productIndex }
      window.$('[data-product-active-offer=' + offerIndex + '-' + productIndex + ']').focus().select()
    },
    emitOffer (offerId, index) {
      let offer = this.offers.find(o => parseInt(o.id) === parseInt(offerId))
      let vm = this
      let offerStatus = offer.checked
      this.$parent.$refs.clientCompRef.selected_partner = this.$parent.$refs.clientCompRef.partners.find(x => x.id === offer.partner.id)
      this.$parent.totalDiscountCheckbox = parseInt(offer.show_total_discount) === 1
      this.$parent.discount = parseFloat(offer.discount)
      offer.products.forEach(function (product) {
        if (offerStatus === true) {
          vm.checkedOffers.push(index)
          vm.emitOfferRow = offerStatus
          product.checked = true
          vm.emitProductRow += 1
        } else {
          if (vm.checkedOffers.length) {
            let ordIndex = vm.checkedOffers.indexOf(index)
            if (ordIndex !== -1) vm.checkedOffers.splice(index, 1)
          }
          product.checked = false
          vm.emitOfferRow += 1
        }
        vm.showOnCollapse(index)
        vm.emitProduct(offerId, product.id, false, product, false)
        vm.emitOfferRow += 1
        vm.emitProductRow += 1
      })
      this.resetOfferCheckbox(offer)
      // vm.componentProductsKey += 1
    },
    showOnCollapse (index) {
      let target = document.getElementsByClassName('collapse-all')
      if (target[0].classList.contains('collapsed')) {
        let collapseOffer = document.getElementById('collapse-offer' + index)
        collapseOffer.classList.add('show')
        collapseOffer.style.display = 'block'
      }
    },
    showAllProductsFromOffer (index, id, event) {
      event.stopPropagation()
      let offer = this.showAllProductsFromOfferObject.find(offer => offer.id === id)
      this.offers[index].products = offer.products
      this.componentProductsKey += 1
    },
    resetOfferCheckbox (offer) {
      let vm = this
      let allCheck = true
      offer.products.forEach(function (product) {
        if (product.checked === false) {
          offer.checked = false
          allCheck = false
          return false
        }
      })
      if (allCheck) {
        offer.checked = true
      }
      vm.emitOfferRow += 1
    },
    emitProduct (offerId, prodId, check = true, prod = null) {
      let offer = this.offersAll.find(o => parseInt(o.id) === parseInt(offerId))
      let offerr = this.offers.find(o => parseInt(o.id) === parseInt(offerId))
      // let product = offer.products.find(prods => parseInt(prods.id) === parseInt(prodId)
      // && parseInt(prods.warehouse_id) === parseInt(prod.warehouse_id))

      let productChecked = []
      let filteredInputs = []
      let cloneProduct = window._.cloneDeep(prod)

      if (cloneProduct.checked === true) {
        offer.products.filter(function (product) {
          if (product.checked === true) {
            productChecked.push(product)
          }
        })
        let inputs = document.querySelectorAll("input[data-product='" + offer.id + '-' + prod.id + "']")
        for (let [key, val] of Object.entries(inputs)) {
          let status = val.getAttribute('data-product-can-be-added')
          if (status) {
            filteredInputs.push(val)
          }
        }
        let data = {
          inputs: filteredInputs,
          offerId: offer.id,
          product: cloneProduct
        }
        this.$emit('addItem', data)
      } else {
        productChecked.pop()
        let data = {
          offerId: offer.id,
          productId: prod.id,
          product: cloneProduct
        }
        this.$emit('removeItemFromOffer', data)
      }
      this.resetOfferCheckbox(offerr)
    },
    offerObjectives () {
      let filter = [...new Set(this.offersAll.map(o => o.objective))]
      filter = filter.length > 1 ? filter : null
      return filter
    },
    offerObjectives2 () {
      let filters = this.offersAll.filter(function (offer) {
        if (offer.objective !== '') {
          offer.status = false
          return true
        }
      })
      return filters
    },
    offerDates () {
      let filter = [...new Set(this.offersAll.map(o => o.created_at))]
      filter = filter.length > 1 ? filter : null
      return filter
    },
    applySearch () {
      if (this.search && this.search !== '') {
        let vm = this
        let offerss = window._.cloneDeep(this.offersAll)
        for (let i = 0; i < offerss.length; i++) {
          offerss[i].products = offerss[i].products.filter(function (product) {
            let keywords = vm.search.trim().replace(/\s+/g, ' ').split(' ')
            for (let j = 0; j < keywords.length; j++) {
              if (product.name.toLowerCase().includes(keywords[j].toLowerCase()) || keywords[j] === '') {
                return true
              }
            }
          })
        }
        let searchOffers = []
        for (let i = 0; i < offerss.length; i++) {
          if (offerss[i].products.length) {
            searchOffers.push(offerss[i])
          }
        }
        this.offers = window._.cloneDeep(searchOffers)
      } else {
        this.offers = this.offersAll
      }
    },
    resetFilter (key, filter) {
      let vm = this
      this.offerFilter[key] = []
      this[filter] += 1
      this.offers = this.offersAll
      this.applySearch()
      this.offerFilterKeys.forEach(function (element) {
        if (vm.offerFilter[element].length > 0) {
          vm.offers = vm.offers.filter(offer => vm.offerFilter[element].includes(offer[element]))
        }
      })
    },
    addRemoveFilter: function (key, value) {
      let vm = this
      let index = this.offerFilter[key].indexOf(value)
      if (index === -1) {
        this.offerFilter[key].push(value)
      } else {
        this.offerFilter[key].splice(index, 1)
      }

      this.offers = this.offersAll
      this.applySearch()
      this.offerFilterKeys.forEach(function (element) {
        if (vm.offerFilter[element].length > 0) {
          vm.offers = vm.offers.filter(offer => vm.offerFilter[element].includes(offer[element]))
        }
      })
    },
    getUserOffers (id) {
      OffersService.getUserOffers(id)
        .then((response) => {
          this.offersAll = response.data.data
          for (let i = 0; i < this.offersAll.length; i++) {
            this.offersAll[i]['checked'] = false
            for (let j = 0; j < this.offersAll[i].products.length; j++) {
              this.offersAll[i].products[j]['checked'] = false
              let inputVal = null
              inputVal = this.offersAll[i].products[j].qty_total - this.offersAll[i].products[j].qty_ordered
              this.offersAll[i].products[j]['qty_input'] = inputVal > 0 ? inputVal : null
            }
          }
          this.offers = this.offersAll
          this.showAllProductsFromOfferObject = window._.cloneDeep(this.offers)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getWarehousesById (id) {
      return this.warehouses.find(wrh => parseInt(wrh.id) === parseInt(id))
    }
  },
  async created () {
  }
}
</script>
